// import { useEffect, useMemo, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Layers, UserCheck, ClipboardList, Plus, Save, ClipboardCheck, Edit3, CheckSquare, Square, Upload, Download } from 'lucide-react';
// import { toast } from 'react-toastify';

// import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
// import Tabs from '../../../components/Tabs/Tabs';
// import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';

// import usePayrollEntity from '../../../utils/usePayrollEntity';
// import { toIsoDate } from '../../../utils/dateFormat';
// import { savePayrollEntity } from '../../../action/Payroll';
// import AddPayrollBatchDialog from '../../../components/PayRoll/AddPayrollBatchDialog';
// import PayrollBatchEmployeeService from '../../../services/PayrollBatchEmployeeService';
// import { getEmployeeList } from '../../../action/Employee';
// import { getDesignationList } from '../../../action/Designation';
// import { getLoggedInServiceNo } from '../../../utils/masterDataUtils';
// import useToast from '../../../utils/useToast';
// import Toast from '../../../components/Toast/Toast';
// import { useConfirm } from '../../../utils/ConfirmContext';
// import { fmtMoney } from '../../../utils/payrollFormat';
// import OverrideBatchDialog from '../../../components/PayRoll/OverrideBatchDialog';
// import ImportBatchEmployeesModal from '../../../components/PayRoll/ImportBatchEmployeesModal';

// const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
// const LABEL = TABLE_THEME.fieldLabel;
// const ICON = { size: 15 };

// const TABLE_PROPS = {
//   search: true,
//   searchLabel: 'Search',
//   pageSize: 10,
//   scrollClassName: '',
// };

// const statusColumn = {
//   key: 'status',
//   label: 'Status',
//   align: 'center',
//   render: (r) => <StatusPill label={r.status} />,
// };

// const maskCurrencyInput = (rawValue) => {
//   const digits = String(rawValue ?? "").replace(/\D/g, "");

//   if (!digits) return "";

//   const padded = digits.padStart(3, "0");
//   const cents = padded.slice(-2);

//   const wholeDigits = padded
//     .slice(0, -2)
//     .replace(/^0+(?=\d)/, "");

//   const whole = Number(wholeDigits || "0").toLocaleString("en-US");

//   return `${whole}.${cents}`;
// };

// const parseCurrency = (value) => {
//   if (value === "" || value === null || value === undefined) {
//     return 0;
//   }

//   const n = Number(String(value).replace(/,/g, ""));

//   return Number.isNaN(n) ? 0 : n;
// };

// const formatCurrencyValue = (value) => {
//   if (value === null || value === undefined || value === '') {
//     return '';
//   }

//   const number = Number(String(value).replace(/,/g, ''));

//   if (Number.isNaN(number)) {
//     return '';
//   }

//   return number.toLocaleString('en-US', {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });
// };

// /* A row-level input, sized to sit inside a table cell without stretching it. */
// // const CellInput = ({ value, onChange, disabled, type = 'text', width = 'w-[110px]' }) => (
// //   <input
// //     type={type}
// //     value={value}
// //     disabled={disabled}
// //     onChange={onChange}
// //     className={`${FIELD} ${width} ${type === 'number' ? 'text-right' : ''}
// //       disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed`}
// //   />
// // );

// // const CurrencyCellInput = ({
// //   value,
// //   onChange,
// //   disabled,
// //   width = 'w-[130px]',
// // }) => (
// //   <input
// //     type="text"
// //     inputMode="decimal"
// //     value={value ?? ""}
// //     disabled={disabled}
// //     onChange={(e) => onChange(maskCurrencyInput(e.target.value))}
// //     className={`${FIELD} ${width} text-right
// //       disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed`}
// //   />
// // );


// /* ── Batch Management ────────────────────────────────────────────────────── */
// const BatchManagementTab = () => {
//   const dispatch = useDispatch();

//   const { list, loading } = usePayrollEntity('batchManagement');
//   const { list: periods } = usePayrollEntity('payrollPeriods');
//   const { list: components } = usePayrollEntity('payrollComponents');

//   const { toast, showToast, hideToast } = useToast();

//   const [open, setOpen] = useState(false);

//   const handleSave = async (form) => {
//     await dispatch(savePayrollEntity('batchManagement', form));

//     showToast('Batch added successfully.', 'success')

//     setOpen(false);
//   };

//   const getNextBatchNo = () => {
//     const max = list.reduce((highest, batch) => {
//       const match = /^BATCH(\d+)$/i.exec(batch.batchNo || '');
//       if (!match) return highest;
//       return Math.max(highest, Number(match[1]));
//     }, 0);
//     return `BATCH${String(max + 1).padStart(3, '0')}`;
//   };

//   return (
//     <>
//       <Table
//         {...TABLE_PROPS}
//         title="Batch Management"
//         loading={loading}
//         rows={list}
//         rowKey="id"
//         searchKeys={['batchNo', 'name', 'description']}
//         searchPlaceholder="Search batches..."
//         emptyMessage="No batches found"
//         onAdd={{ label: 'New Batch', icon: <Plus {...ICON} />, onClick: () => setOpen(true) }}
//         columns={[
//           { key: 'batchNo', label: 'Batch No', className: 'font-semibold text-gray-900' },
//           { key: 'name', label: 'Batch Name', grow: true, className: 'text-gray-700' },
//           { key: 'effectiveDate', label: 'Effective Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
//           { key: 'calculationMethod', label: 'Calculation', className: 'text-gray-600' },
//           {
//             key: 'amountPercentage',
//             label: 'Amount (Rs) / Percentage',
//             align: 'right',
//             className: 'font-semibold text-gray-900',
//             render: (r) =>
//               r.calculationMethod === 'Percentage' || r.calculationMethod === 'P'
//                 ? `${r.percentage ?? 0}%`
//                 : fmtMoney(r.amount ?? 0),
//           },
//           statusColumn,
//         ]}
//       />

//       <AddPayrollBatchDialog
//         open={open}
//         onClose={() => setOpen(false)}
//         onSave={handleSave}
//         periods={periods}
//         components={components}
//         suggestedBatchNo={getNextBatchNo()}
//       />

//       <Toast 
//         message={toast?.message}
//         type={toast?.type}
//         onClose={hideToast}
//       />
//     </>
//   );
// };

// /* ── Batch Employee Selection ────────────────────────────────────────────── */
// const BatchEmployeeSelectionTab = ({ refreshKey }) => {
//   const dispatch = useDispatch();

//   const employees = useSelector((state) => state.employee.list);
//   const designations = useSelector((state) => state.designation.list);
//   const batches = useSelector((state) => state.payroll.entities.batchManagement?.list || []);

//   const { toast, showToast, hideToast } = useToast();

//   const [selectedBatch, setSelectedBatch] = useState('');
//   const [rows, setRows] = useState([]);
//   const [batchEmployees, setBatchEmployees] = useState([]);
//   const [statusFilter, setStatusFilter] = useState('ALL');
//   const [editingRow, setEditingRow] = useState(null);
//   const [fetchingBatchEmployees, setFetchingBatchEmployees] = useState(false);

//   const selectedBatchData = batches.find((b) => String(b.id) === String(selectedBatch));

//   // Handles both full text ('Fixed') and API code ('F')
//   const isFixedBatch =
//     selectedBatchData?.calculationMethod === 'Fixed' ||
//     selectedBatchData?.calculationMethod === 'F';

//   useEffect(() => {
//     dispatch(getEmployeeList()).catch(() => {});
//     dispatch(getDesignationList()).catch(() => {});
//   }, [dispatch]);

//   const designationMap = useMemo(() => {
//     const map = {};
//     (designations || []).forEach((d) => {
//       map[d.HED_DESIGNATION_ID] = d.HED_DESIGNATION_NAME;
//     });
//     return map;
//   }, [designations]);

//   useEffect(() => {
//     if (!selectedBatch || refreshKey === 0) return;

//     handleBatchChange({
//       target: { value: selectedBatch },
//     });
//   }, [refreshKey]);

//   const handleBatchChange = async (e) => {
//     const batchId = e.target.value;
//     setSelectedBatch(batchId);

//     // 1. Cleared batch: reset state and empty table
//     if (!batchId) {
//       setBatchEmployees([]);
//       setRows([]);
//       return;
//     }

//     const batch = batches.find((b) => String(b.id) === String(batchId));
//     setFetchingBatchEmployees(true);

//     try {
//       const response = await PayrollBatchEmployeeService.GetPayRollEmpByBatchId(batchId);
//       const batchList = response?.data?.ResultSet || [];
//       setBatchEmployees(batchList);

//       const map = {};
//       batchList.forEach((item) => {
//         map[item.HED_SERVICE_NO] = item;
//       });

//       // Build rows for the newly selected batch
//       const initialRows = employees.map((emp) => {
//         const batchEmp = map[emp.HED_SERVICE_NO];
//         const isIncluded = batchEmp?.HPBE_IS_ACTIVE === 'True';

//         return {
//           employeeId: emp.HED_EMPLOYEE_ID,
//           empNo: emp.HED_SERVICE_NO,
//           name: emp.HED_REPORT_NAME,
//           designation: designationMap[emp.HED_DESIGNATION_ID] || '',
//           included: isIncluded,
//           amount: formatCurrencyValue(batchEmp?.HPBE_AMOUNT ?? batch?.amount ?? 0),
//           percentage: Number(batchEmp?.HPBE_PERCENTAGE ?? batch?.percentage ?? 0),
//           overrideReason: batchEmp?.HPBE_OVERRIDE_REASON ?? '',
//           remarks: batchEmp?.HPBE_REMARKS ?? '',
//           batchEmployeeId: batchEmp?.HPBE_BATCH_EMPLOYEE_ID ?? null,
//           status: batchEmp
//             ? batchEmp.HPBE_IS_ACTIVE === 'True'
//               ? 'Active'
//               : 'Inactive'
//             : 'Not Selected',
//         };
//       });

//       setRows(initialRows);
//     } catch (err) {
//       console.error('Failed to load batch employees', err);
//       showToast('Failed to load employees for the selected batch.', 'error');
//     } finally {
//       setFetchingBatchEmployees(false);
//     }
//   };

//   const saveChanges = async () => {
//     if (!selectedBatch) {
//       showToast('Please select a batch first.', 'warning');
//       return;
//     }

//     const originalMap = {};
//     batchEmployees.forEach((emp) => {
//       originalMap[emp.HED_SERVICE_NO] = emp;
//     });

//     let added = 0;
//     let removed = 0;

//     try {
//       for (const emp of rows) {
//         const original = originalMap[emp.empNo];

//         if (!original && emp.included) {
//           await PayrollBatchEmployeeService.AddPayRollEmp({
//             batchId: selectedBatch,
//             employeeId: emp.employeeId,
//             amount: parseCurrency(emp.amount),
//             percentage: emp.percentage,
//             isIncluded: 1,
//             isProcessed: 0,
//             isActive: 1,
//             overrideReason: emp.overrideReason,
//             remarks: emp.remarks,
//             createdBy: getLoggedInServiceNo(),
//           });
//           added++;
//         } else if (original) {
//           const currentActive = original.HPBE_IS_ACTIVE === 'True';
//           const changed = currentActive !== emp.included;

//           if (changed) {
//             await PayrollBatchEmployeeService.UpdatePayRollEmp({
//               batchEmployeeId: original.HPBE_BATCH_EMPLOYEE_ID,
//               isActive: emp.included ? 1 : 0,
//             });
//           }

//           if (emp.included) {
//             added++;
//           } else {
//             removed++;
//           }
//         }
//       }

//       await handleBatchChange({ target: { value: selectedBatch } });

//       if (added || removed) {
//         showToast(`Batch updated successfully. ${added} active, ${removed} excluded.`, 'success');
//       } else {
//         toast.info('No changes to save.', { autoClose: 1500 });
//       }
//     } catch (error) {
//       console.error(error);
//       showToast('Failed to update batch employees.', 'error');
//     }
//   };

//   // Do not show any rows if no batch is selected
//   const filteredRows = useMemo(() => {
//     if (!selectedBatch) return [];
//     return rows.filter((row) => {
//       if (statusFilter === 'ALL') return true;
//       return row.status === statusFilter;
//     });
//   }, [rows, statusFilter, selectedBatch]);

//   const toggleIncluded = (r) => {
//     setRows((prev) =>
//       prev.map((x) =>
//         x.employeeId === r.employeeId
//           ? {
//               ...x,
//               included: !x.included,
//               amount: !x.included
//                 ? formatCurrencyValue(selectedBatchData?.amount ?? 0)
//                 : x.amount,
//               percentage: !x.included
//                 ? Number(selectedBatchData?.percentage ?? 0)
//                 : x.percentage,
//             }
//           : x
//       )
//     );
//   };

//   const toggleSelectAll = (select) => {
//     if (!selectedBatch) return;
//     const targetEmpIds = new Set(filteredRows.map((r) => r.employeeId));

//     setRows((prev) =>
//       prev.map((x) => {
//         if (!targetEmpIds.has(x.employeeId)) return x;
//         return {
//           ...x,
//           included: select,
//           amount: select
//             ? formatCurrencyValue(selectedBatchData?.amount ?? 0)
//             : x.amount,
//           percentage: select
//             ? Number(selectedBatchData?.percentage ?? 0)
//             : x.percentage,
//         };
//       })
//     );
//   };

//   const patchRow = (r, patch) => {
//     setRows((prev) =>
//       prev.map((x) => (x.employeeId === r.employeeId ? { ...x, ...patch } : x))
//     );
//   };

//   const isCalculationOverridden = (r) => {
//     if (!selectedBatchData) return false;
//     if (isFixedBatch) {
//       return parseCurrency(r.amount) !== Number(selectedBatchData.amount ?? 0);
//     }
//     return Number(r.percentage) !== Number(selectedBatchData.percentage ?? 0);
//   };

//   const areAllFilteredSelected =
//     filteredRows.length > 0 && filteredRows.every((r) => r.included);

//   return (
//     <>
//       <Table
//         {...TABLE_PROPS}
//         title="Batch Employee Selection"
//         loading={fetchingBatchEmployees}
//         loadingMessage="Loading batch employees..."
//         rows={filteredRows}
//         rowKey="employeeId"
//         searchKeys={['empNo', 'name', 'designation']}
//         searchPlaceholder="Search employees..."
//         emptyMessage={
//           !selectedBatch
//             ? 'Please select a batch to assign employees.'
//             : 'No matching employees found'
//         }
//         onAdd={{ label: 'Save Changes', icon: <Save {...ICON} />, onClick: saveChanges }}
//         toolbarBeforeSearch={
//           <div className="w-[260px] max-w-full">
//             <span className={LABEL}>Batch</span>
//             <select
//               value={selectedBatch}
//               onChange={handleBatchChange}
//               className={`${FIELD} w-full`}
//             >
//               <option value="">-- Select Batch --</option>
//               {batches.map((batch) => (
//                 <option key={batch.id} value={batch.id}>
//                   {batch.batchNo} - {batch.name}
//                 </option>
//               ))}
//             </select>
//           </div>
//         }
//         toolbarExtra={
//           <div className="flex flex-wrap items-end gap-3">
//             <div className="w-[150px]">
//               <span className={LABEL}>Status</span>
//               <select
//                 value={statusFilter}
//                 onChange={(e) => setStatusFilter(e.target.value)}
//                 disabled={!selectedBatch}
//                 className={`${FIELD} w-full disabled:opacity-50`}
//               >
//                 <option value="ALL">All Employees</option>
//                 <option value="Not Selected">Not Selected</option>
//                 <option value="Active">Active</option>
//                 <option value="Inactive">Inactive</option>
//               </select>
//             </div>

//             {selectedBatch && (
//               <button
//                 type="button"
//                 onClick={() => toggleSelectAll(!areAllFilteredSelected)}
//                 className="h-9 px-3 border border-gray-200 rounded-lg text-xs font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors inline-flex items-center gap-1.5 cursor-pointer shadow-xs"
//               >
//                 {areAllFilteredSelected ? (
//                   <>
//                     <Square size={14} className="text-gray-500" />
//                     Deselect All
//                   </>
//                 ) : (
//                   <>
//                     <CheckSquare size={14} className="text-primary-600" />
//                     Select All
//                   </>
//                 )}
//               </button>
//             )}
//           </div>
//         }
//         columns={[
//           {
//             key: 'included',
//             label: 'Include',
//             align: 'center',
//             sortable: false,
//             render: (r) => (
//               <input
//                 type="checkbox"
//                 checked={r.included}
//                 disabled={!selectedBatch}
//                 onChange={() => toggleIncluded(r)}
//                 className="w-4 h-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 cursor-pointer accent-primary-600 disabled:opacity-40"
//               />
//             ),
//           },
//           {
//             key: 'name',
//             label: 'Employee',
//             grow: true,
//             className: 'font-semibold text-gray-900',
//             render: (r) => (
//               <div>
//                 <span>{r.name}</span>
//                 <span className="ml-1.5 text-xs font-normal text-gray-500">({r.empNo})</span>
//               </div>
//             ),
//           },
//           { key: 'designation', label: 'Designation', className: 'text-gray-600' },
//           {
//             key: 'calculation',
//             label: isFixedBatch ? 'Amount' : 'Percentage',
//             align: 'right',
//             sortable: false,
//             render: (r) => {
//               const overridden = isCalculationOverridden(r);
//               const displayVal = isFixedBatch
//                 ? fmtMoney(parseCurrency(r.amount))
//                 : `${r.percentage ?? 0}%`;

//               return (
//                 <div className="flex items-center justify-end gap-2">
//                   {overridden && (
//                     <span className="text-[10px] uppercase font-bold tracking-wider px-1.5 py-0.5 rounded bg-amber-50 text-amber-700 border border-amber-200/60">
//                       Overridden
//                     </span>
//                   )}
//                   <span className={overridden ? 'font-bold text-gray-900' : 'text-gray-600'}>
//                     {displayVal}
//                   </span>
//                 </div>
//               );
//             },
//           },
//           {
//             key: 'overrideReason',
//             label: 'Reason',
//             className: 'text-gray-500 max-w-[180px] truncate',
//             render: (r) => r.overrideReason || <span className="text-gray-300">—</span>,
//           },
//           statusColumn,
//           {
//             key: 'actions',
//             label: 'Actions',
//             align: 'center',
//             sortable: false,
//             render: (r) => (
//               <button
//                 type="button"
//                 disabled={!r.included || !selectedBatch}
//                 onClick={() => setEditingRow(r)}
//                 className="p-1.5 text-gray-500 hover:text-primary-600 hover:bg-gray-100 rounded-md transition-colors disabled:opacity-30 disabled:pointer-events-none"
//                 title="Override amount or reason"
//               >
//                 <Edit3 size={15} />
//               </button>
//             ),
//           },
//         ]}
//       />

//       <OverrideBatchDialog
//         isOpen={Boolean(editingRow)}
//         row={editingRow}
//         batchType={isFixedBatch ? 'Fixed' : 'Percentage'}
//         onClose={() => setEditingRow(null)}
//         onSave={(data) => {
//           patchRow(editingRow, data);
//           setEditingRow(null);
//         }}
//       />

//       <Toast message={toast?.message} type={toast?.type} onClose={hideToast} />
//     </>
//   );
// };

// /* ── Batch Approval ──────────────────────────────────────────────────────── */
// const BatchApprovalTab = () => {
//   const dispatch = useDispatch();
//   const confirm = useConfirm();

//   const { list: batches, loading } = usePayrollEntity('batchManagement'); 
//   const { toast, showToast, hideToast } = useToast();

//   const [employeeCounts, setEmployeeCounts] = useState({});
//   const [loadingEmployees, setLoadingEmployees] = useState(true);
//   const [approvingBatchId, setApprovingBatchId] = useState(null);

//   // Only batches where status = 'Incomplete' appears here
//   const pendingBatches = batches.filter(
//     (batch) => batch.status === 'Incomplete' || batch.status === 'I'
//   );

//   // Load employee counts for all incomplete batches
//   useEffect(() => {
//     let cancelled = false;

//     const loadEmployeeCounts = async () => {
//       if (!pendingBatches.length) {
//         setEmployeeCounts({});
//         setLoadingEmployees(false);
//         return;
//       }

//       setLoadingEmployees(true);

//       try {
//         const results = await Promise.all(
//           pendingBatches.map(async (batch) => {
//             try {
//               const response = await PayrollBatchEmployeeService.GetPayRollEmpByBatchId(batch.id);

//               const employees = response?.data?.ResultSet || [];

//               const activeEmployees = employees.filter((emp) => emp.HPBE_IS_ACTIVE === "True");

//               return {
//                 batchId: batch.id,
//                 count: activeEmployees.length,
//               };
//             } catch (error) {
//               console.error(`Failed to load employees for batch ${batch.id}`, error);

//               return {
//                 batchId: batch.id,
//                 count: 0
//               }
//             }
//           })
//         );

//         const counts = {};

//         results.forEach(({ batchId, count }) => {
//           counts[batchId] = count;
//         });

//         setEmployeeCounts(counts);
//       } finally {
//         if (!cancelled) {
//           setLoadingEmployees(false);
//         }
//       }
//     };

//     loadEmployeeCounts();

//     return () => {
//       cancelled = true;
//     }
//   }, [batches]);

//   const handleApprove = async (batch) => {
//     const employeeCount = employeeCounts[batch.id] ?? 0;

//     if (employeeCount === 0) {
//       // toast.warning('This batch cannot be approved because it has no employees.', { autoClose: 2000 });
//       showToast(`This batch cannot be approved because it has no employees.`, 'warning');
//       return;
//     }

//     const confirmed = await confirm({
//       title: "Approve this batch?",
//       message: "After a batch is approved, employees can no longer be added or removed. Do you still wish to proceed?",
//       confirmLabel: "Approve",
//       cancelLabel: "Cancel",
//     })

//     if (!confirmed) return;

//     try {
//       setApprovingBatchId(batch.id);

//       await dispatch(savePayrollEntity('batchManagement', {
//         batchId: batch.id,
//         status: 'A',
//       }, true));

//       // toast.success(`Batch ${batch.batchNo} approved successfully.`, {
//       //   autoClose: 1500,
//       // });
//       showToast(`Batch ${batch.batchNo} approved successfully.`, 'success');
//     } catch (error) {
//       console.error(error);
//       //toast.error(error?.message || 'Failed to approve the batch', { autoClose: 2000 })
//       showToast(error?.message || 'Failed to approve the batch', 'error');
//     } finally {
//       setApprovingBatchId(null);
//     }
//   }

//   return (
//     <>
//       <Table
//         {...TABLE_PROPS}
//         title="Batch Approval"
//         loading={loading}
//         rows={pendingBatches}
//         rowKey="id"
//         searchKeys={['batchNo', 'name', 'description']}
//         searchPlaceholder="Search pending batches..."
//         emptyMessage="No batches awaiting approval"
//         columns={[
//           {
//             key: 'batchNo',
//             label: 'Batch No',
//             className: 'font-semibold text-gray-900',
//           },
//           {
//             key: 'name',
//             label: 'Batch Name',
//             grow: true,
//             className: 'text-gray-700',
//           },
//           {
//             key: 'effectiveDate',
//             label: 'Effective Date',
//             align: 'center',
//             className: 'text-gray-600 tabular-nums',
//             render: (r) => toIsoDate(r.effectiveDate),
//           },
//           {
//             key: 'calculationMethod',
//             label: 'Calculation',
//             className: 'text-gray-600',
//           },
//           {
//             key: 'amountPercentage',
//             label: 'Amount (Rs) / Percentage',
//             align: 'right',
//             className: 'font-semibold text-gray-900',
//             render: (r) =>
//               r.calculationMethod === 'Percentage' ||
//               r.calculationMethod === 'P'
//                 ? `${r.percentage ?? 0}%`
//                 : fmtMoney(r.amount ?? 0),
//           },
//           {
//             key: 'employeeCount',
//             label: 'Employees',
//             align: 'center',
//             className: 'font-semibold text-gray-900',
//             render: (r) => {
//               const count = employeeCounts[r.id];

//               if (count === undefined) {
//                 return '...';
//               }

//               return count;
//             },
//           },
//           statusColumn,
//           {
//             key: 'approve',
//             label: 'Action',
//             align: 'center',
//             sortable: false,
//             render: (r) => {
//               const count = employeeCounts[r.id] ?? 0;
//               const isApproving = approvingBatchId === r.id;
//               const disabled =
//                 loadingEmployees ||
//                 count === 0 ||
//                 isApproving;

//               return (
//                 <button
//                   type="button"
//                   disabled={disabled}
//                   onClick={() => handleApprove(r)}
//                   className="
//                     inline-flex items-center justify-center
//                     rounded-md px-3 py-1.5
//                     text-sm font-medium
//                     bg-primary-600 text-white
//                     hover:bg-primary-700
//                     disabled:bg-gray-300
//                     disabled:text-gray-500
//                     disabled:cursor-not-allowed
//                   "
//                   title={
//                     count === 0
//                       ? 'Cannot approve a batch with no employees'
//                       : 'Approve batch'
//                   }
//                 >
//                   {isApproving ? 'Approving...' : 'Approve'}
//                 </button>
//               );
//             },
//           },
//         ]}
//       />

//       <Toast 
//         message={toast?.message}
//         type={toast?.type}
//         onClose={hideToast}
//       />
//     </>
//   );
// };

// /* ── Page ────────────────────────────────────────────────────────────────── */
// const PayrollBatches = () => {
//   const [importModalOpen, setImportModalOpen] = useState(false);
//   const [refreshBatchEmployees, setRefreshBatchEmployees] = useState(0);

//   const { toast, showToast, hideToast } = useToast();

//   // Redux data needed by the modal
//   const employees = useSelector((state) => state.employee.list || []);
//   const batches = useSelector((state) => state.payroll.entities.batchManagement?.list || []);

//   const tabs = [
//     { key: 'management', label: 'Batch Management', icon: <Layers {...ICON} />, content: <BatchManagementTab /> },
//     { key: 'selection', label: 'Batch Employee Selection', icon: <UserCheck {...ICON} />, content: <BatchEmployeeSelectionTab refreshKey={refreshBatchEmployees} /> },
//     { key: 'approval', label: 'Batch Approval', icon: <ClipboardCheck {...ICON} />, content: <BatchApprovalTab /> },
//   ];

//   return (
//     <div className="p-6 space-y-4">
//       <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4'>
//         <Breadcrumb
//           trail={['Payroll', 'Payroll Batches']}
//           title="Payroll Batches"
//           subtitle="Group employees into payroll batches and route them for approval."
//         />

//         <button
//           type='button'
//           onClick={() => setImportModalOpen(true)}
//           className='bg-primary-600 text-white hover:bg-primary-700 inline-flex items-center gap-2 h-9 px-4 rounded-lg text-xs font-semibold border border-gray-200 shadow-xs transition-colors shrink-0 self-start sm:self-auto cursor-pointer'
//         >
//           <Download size={14} className='text-white' />
//           Import Batch Employees
//         </button>
//       </div>

//       <Tabs tabs={tabs} defaultTab="management" />

//       <ImportBatchEmployeesModal 
//         isOpen={importModalOpen}
//         onClose={() => setImportModalOpen(false)}
//         batches={batches}
//         employees={employees}
//         onImportSuccess={() => {
//           setRefreshBatchEmployees((v) => v + 1)
//           // showToast("Batch employees imported successfully.", "success")
//         }}
//       />

//       <Toast 
//         message={toast?.message}
//         type={toast?.type}
//         onClose={hideToast}
//       />
//     </div>
//   );
// };

// export default PayrollBatches;





import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Layers, UserCheck, ClipboardList, Plus, Save, ClipboardCheck, Edit3, CheckSquare, Square, Upload, Download, Eye, X } from 'lucide-react';
import { toast } from 'react-toastify';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import Tabs from '../../../components/Tabs/Tabs';
import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';

import usePayrollEntity from '../../../utils/usePayrollEntity';
import { toIsoDate } from '../../../utils/dateFormat';
import { savePayrollEntity } from '../../../store/slices/payrollSlice';
import AddPayrollBatchDialog from '../../../components/PayRoll/AddPayrollBatchDialog';
import PayrollBatchEmployeeService from '../../../services/PayrollBatchEmployeeService';
import { fetchAllEmployees } from '../../../store/slices/employeeSlice';
import { getDesignationList } from '../../../store/slices/designationSlice';
import { getLoggedInServiceNo } from '../../../utils/masterDataUtils';
import useToast from '../../../utils/useToast';
import Toast from '../../../components/Toast/Toast';
import { useConfirm } from '../../../utils/ConfirmContext';
import { fmtMoney } from '../../../utils/payrollFormat';
import OverrideBatchDialog from '../../../components/PayRoll/OverrideBatchDialog';
import ImportBatchEmployeesModal from '../../../components/PayRoll/ImportBatchEmployeesModal';

const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
const LABEL = TABLE_THEME.fieldLabel;
const ICON = { size: 15 };

const TABLE_PROPS = {
  search: true,
  searchLabel: 'Search',
  pageSize: 10,
  scrollClassName: '',
};

const statusColumn = {
  key: 'status',
  label: 'Status',
  align: 'center',
  render: (r) => <StatusPill label={r.status} />,
};

const maskCurrencyInput = (rawValue) => {
  const digits = String(rawValue ?? "").replace(/\D/g, "");

  if (!digits) return "";

  const padded = digits.padStart(3, "0");
  const cents = padded.slice(-2);

  const wholeDigits = padded
    .slice(0, -2)
    .replace(/^0+(?=\d)/, "");

  const whole = Number(wholeDigits || "0").toLocaleString("en-US");

  return `${whole}.${cents}`;
};

const parseCurrency = (value) => {
  if (value === "" || value === null || value === undefined) {
    return 0;
  }

  const n = Number(String(value).replace(/,/g, ""));

  return Number.isNaN(n) ? 0 : n;
};

const formatCurrencyValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const number = Number(String(value).replace(/,/g, ''));

  if (Number.isNaN(number)) {
    return '';
  }

  return number.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/* ── Batch Management ────────────────────────────────────────────────────── */
const BatchManagementTab = () => {
  const dispatch = useDispatch();

  const { list, loading } = usePayrollEntity('batchManagement');
  const { list: periods } = usePayrollEntity('payrollPeriods');
  const { list: components } = usePayrollEntity('payrollComponents');

  const { toast, showToast, hideToast } = useToast();

  const [open, setOpen] = useState(false);

  const componentMap = useMemo(() => {
    const map = {};
    (components || []).forEach((c) => {
      map[String(c.id)] = c.name;
    });
    return map;
  }, [components]);

  const handleSave = async (form) => {
    await dispatch(savePayrollEntity('batchManagement', form));

    showToast('Batch added successfully.', 'success')

    setOpen(false);
  };

  const getNextBatchNo = () => {
    const max = list.reduce((highest, batch) => {
      const match = /^BATCH(\d+)$/i.exec(batch.batchNo || '');
      if (!match) return highest;
      return Math.max(highest, Number(match[1]));
    }, 0);
    return `BATCH${String(max + 1).padStart(3, '0')}`;
  };

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Batch Management"
        loading={loading}
        rows={list}
        rowKey="id"
        searchKeys={['batchNo', 'name', 'description']}
        searchPlaceholder="Search batches..."
        emptyMessage="No batches found"
        onAdd={{ label: 'New Batch', icon: <Plus {...ICON} />, onClick: () => setOpen(true) }}
        columns={[
          { key: 'batchNo', label: 'Batch No', className: 'font-semibold text-gray-900' },
          { key: 'name', label: 'Batch Name', grow: true, className: 'text-gray-700' },
          {
            key: 'batchType',
            label: 'Type',
            align: 'center',
            render: (r) => {
              const isRecurring = r.periodId === null 
                || r.periodId === undefined
                || String(r.periodId).trim() === '';
                
              return (
                <span
                  className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ${
                    isRecurring
                      ? 'bg-orange-50 text-orange-700 ring-1 ring-inset ring-orange-600/20'
                      : 'bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-600/20'
                  }`}
                >
                  {isRecurring ? 'Recurring' : 'One-Time'}
                </span>
              );
            }
          },
          {
            key: 'component',
            label: 'Component',
            className: 'text-gray-700 font-medium',
            render: (r) =>
              r.componentName ||
              r.component?.name ||
              componentMap[String(r.componentId)] ||
              '—',
          },
          { key: 'effectiveDate', label: 'Effective Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
          { key: 'calculationMethod', label: 'Calculation', className: 'text-gray-600' },
          {
            key: 'amountPercentage',
            label: 'Amount (Rs) / Percentage',
            align: 'right',
            className: 'font-semibold text-gray-900',
            render: (r) =>
              r.calculationMethod === 'Percentage' || r.calculationMethod === 'P'
                ? `${r.percentage ?? 0}%`
                : fmtMoney(r.amount ?? 0),
          },
          statusColumn,
        ]}
      />

      <AddPayrollBatchDialog
        open={open}
        onClose={() => setOpen(false)}
        onSave={handleSave}
        periods={periods}
        components={components}
        suggestedBatchNo={getNextBatchNo()}
      />

      <Toast 
        message={toast?.message}
        type={toast?.type}
        onClose={hideToast}
      />
    </>
  );
};

/* ── Batch Employee Selection ────────────────────────────────────────────── */
const BatchEmployeeSelectionTab = ({ refreshKey }) => {
  const dispatch = useDispatch();

  const employees = useSelector((state) => state.employees.employees);
  const designations = useSelector((state) => state.designationSlice.designations);
  const batches = useSelector((state) => state.payroll.entities.batchManagement?.list || []);

  const { toast, showToast, hideToast } = useToast();

  const [selectedBatch, setSelectedBatch] = useState('');
  const [rows, setRows] = useState([]);
  const [batchEmployees, setBatchEmployees] = useState([]);
  const [statusFilter, setStatusFilter] = useState('ALL');
  const [editingRow, setEditingRow] = useState(null);
  const [fetchingBatchEmployees, setFetchingBatchEmployees] = useState(false);

  const selectedBatchData = batches.find((b) => String(b.id) === String(selectedBatch));

  // Handles both full text ('Fixed') and API code ('F')
  const isFixedBatch =
    selectedBatchData?.calculationMethod === 'Fixed' ||
    selectedBatchData?.calculationMethod === 'F';

  useEffect(() => {
    dispatch(fetchAllEmployees());
    dispatch(getDesignationList());
  }, [dispatch]);

  const designationMap = useMemo(() => {
    const map = {};
    (designations || []).forEach((d) => {
      map[d.HED_DESIGNATION_ID] = d.HED_DESIGNATION_NAME;
    });
    return map;
  }, [designations]);

  useEffect(() => {
    if (!selectedBatch || refreshKey === 0) return;

    handleBatchChange({
      target: { value: selectedBatch },
    });
  }, [refreshKey]);

  const handleBatchChange = async (e) => {
    const batchId = e.target.value;
    setSelectedBatch(batchId);

    // 1. Cleared batch: reset state and empty table
    if (!batchId) {
      setBatchEmployees([]);
      setRows([]);
      return;
    }

    const batch = batches.find((b) => String(b.id) === String(batchId));
    setFetchingBatchEmployees(true);

    try {
      const response = await PayrollBatchEmployeeService.GetPayRollEmpByBatchId(batchId);
      const batchList = response?.data?.ResultSet || [];
      setBatchEmployees(batchList);

      const map = {};
      batchList.forEach((item) => {
        map[item.HED_SERVICE_NO] = item;
      });

      // Build rows for the newly selected batch
      const initialRows = employees.map((emp) => {
        const batchEmp = map[emp.HED_SERVICE_NO];
        const isIncluded = batchEmp?.HPBE_IS_ACTIVE === 'True';

        return {
          employeeId: emp.HED_EMPLOYEE_ID,
          empNo: emp.HED_SERVICE_NO,
          name: emp.HED_REPORT_NAME,
          designation: designationMap[emp.HED_DESIGNATION_ID] || '',
          included: isIncluded,
          amount: formatCurrencyValue(batchEmp?.HPBE_AMOUNT ?? batch?.amount ?? 0),
          percentage: Number(batchEmp?.HPBE_PERCENTAGE ?? batch?.percentage ?? 0),
          overrideReason: batchEmp?.HPBE_OVERRIDE_REASON ?? '',
          remarks: batchEmp?.HPBE_REMARKS ?? '',
          batchEmployeeId: batchEmp?.HPBE_BATCH_EMPLOYEE_ID ?? null,
          status: batchEmp
            ? batchEmp.HPBE_IS_ACTIVE === 'True'
              ? 'Active'
              : 'Inactive'
            : 'Not Selected',
        };
      });

      setRows(initialRows);
    } catch (err) {
      console.error('Failed to load batch employees', err);
      showToast('Failed to load employees for the selected batch.', 'error');
    } finally {
      setFetchingBatchEmployees(false);
    }
  };

  // const saveChanges = async () => {
  //   if (!selectedBatch) {
  //     showToast('Please select a batch first.', 'warning');
  //     return;
  //   }

  //   const originalMap = {};
  //   batchEmployees.forEach((emp) => {
  //     originalMap[emp.HED_SERVICE_NO] = emp;
  //   });

  //   let added = 0;
  //   let removed = 0;

  //   try {
  //     for (const emp of rows) {
  //       const original = originalMap[emp.empNo];

  //       if (!original && emp.included) {
  //         await PayrollBatchEmployeeService.AddPayRollEmp({
  //           batchId: selectedBatch,
  //           employeeId: emp.employeeId,
  //           amount: isFixedBatch ? parseCurrency(emp.amount) : null,
  //           percentage: emp.percentage,
  //           isIncluded: 1,
  //           isProcessed: 0,
  //           isActive: 1,
  //           overrideReason: emp.overrideReason,
  //           remarks: emp.remarks,
  //           createdBy: getLoggedInServiceNo(),
  //         });
  //         added++;
  //       } else if (original) {
  //         const currentActive = original.HPBE_IS_ACTIVE === 'True';
  //         const changed = currentActive !== emp.included;

  //         if (changed) {
  //           await PayrollBatchEmployeeService.UpdatePayRollEmp({
  //             batchEmployeeId: original.HPBE_BATCH_EMPLOYEE_ID,
  //             isActive: emp.included ? 1 : 0,
  //           });
  //         }

  //         if (emp.included) {
  //           added++;
  //         } else {
  //           removed++;
  //         }
  //       }
  //     }

  //     await handleBatchChange({ target: { value: selectedBatch } });

  //     if (added || removed) {
  //       showToast(`Batch updated successfully. ${added} active, ${removed} excluded.`, 'success');
  //     } else {
  //       toast.info('No changes to save.', { autoClose: 1500 });
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     showToast('Failed to update batch employees.', 'error');
  //   }
  // };
  
  const saveChanges = async () => {
    if (!selectedBatch) {
      showToast('Please select a batch first.', 'warning');
      return;
    }

    const originalMap = {};
    batchEmployees.forEach((emp) => {
      originalMap[emp.HED_SERVICE_NO] = emp;
    });

    let added = 0;
    let updated = 0;
    let removed = 0;

    try {
      for (const emp of rows) {
        const original = originalMap[emp.empNo];
        const parsedAmount = isFixedBatch ? parseCurrency(emp.amount) : null;
        const parsedPercentage = !isFixedBatch ? Number(emp.percentage ?? 0) : null;

        // ── Scenario 1: New Employee Added to Batch ──
        if (!original && emp.included) {
          await PayrollBatchEmployeeService.AddPayRollEmp({
            batchId: selectedBatch,
            employeeId: emp.employeeId,
            amount: parsedAmount,
            percentage: parsedPercentage,
            isIncluded: 1,
            isProcessed: 0,
            isActive: 1,
            overrideReason: emp.overrideReason || '',
            remarks: emp.remarks || '',
            createdBy: getLoggedInServiceNo() || 'SYSTEM',
          });
          added++;
        } 
        // ── Scenario 2: Existing Employee (Update / Override / Inclusion Change) ──
        else if (original) {
          const origActive = original.HPBE_IS_ACTIVE === 'True';
          const origAmount = Number(original.HPBE_AMOUNT ?? 0);
          const origPercentage = Number(original.HPBE_PERCENTAGE ?? 0);
          const origReason = original.HPBE_OVERRIDE_REASON || '';
          const origRemarks = original.HPBE_REMARKS || '';

          const activeChanged = origActive !== emp.included;
          const amountChanged = isFixedBatch && origAmount !== (parsedAmount ?? 0);
          const percentageChanged = !isFixedBatch && origPercentage !== (parsedPercentage ?? 0);
          const reasonChanged = origReason !== (emp.overrideReason || '');
          const remarksChanged = origRemarks !== (emp.remarks || '');

          const hasChanged =
            activeChanged ||
            amountChanged ||
            percentageChanged ||
            reasonChanged ||
            remarksChanged;

          if (hasChanged) {
            await PayrollBatchEmployeeService.UpdatePayRollEmp({
              batchEmployeeId: original.HPBE_BATCH_EMPLOYEE_ID,
              employeeId: emp.employeeId,
              batchId: selectedBatch,
              amount: parsedAmount,
              percentage: parsedPercentage,
              overrideReason: emp.overrideReason || '',
              remarks: emp.remarks || '',
              isActive: emp.included ? 1 : 0,
              updatedBy: getLoggedInServiceNo() || 'SYSTEM',
            });

            if (activeChanged && !emp.included) {
              removed++;
            } else {
              updated++;
            }
          }
        }
      }

      // Refresh the table with updated data from the backend
      await handleBatchChange({ target: { value: selectedBatch } });

      if (added || updated || removed) {
        showToast(
          `Batch updated successfully. (${added} added, ${updated} updated, ${removed} excluded)`,
          'success'
        );
      } else {
        toast.info('No changes to save.', { autoClose: 1500 });
      }
    } catch (error) {
      console.error('Failed to save batch employees:', error);
      showToast('Failed to update batch employees.', 'error');
    }
  };
  
  
  const filteredRows = useMemo(() => {
    if (!selectedBatch) return [];
    return rows.filter((row) => {
      if (statusFilter === 'ALL') return true;
      return row.status === statusFilter;
    });
  }, [rows, statusFilter, selectedBatch]);

  const toggleIncluded = (r) => {
    setRows((prev) =>
      prev.map((x) =>
        x.employeeId === r.employeeId
          ? {
              ...x,
              included: !x.included,
              amount: !x.included
                ? formatCurrencyValue(selectedBatchData?.amount ?? 0)
                : x.amount,
              percentage: !x.included
                ? Number(selectedBatchData?.percentage ?? 0)
                : x.percentage,
            }
          : x
      )
    );
  };

  const toggleSelectAll = (select) => {
    if (!selectedBatch) return;
    const targetEmpIds = new Set(filteredRows.map((r) => r.employeeId));

    setRows((prev) =>
      prev.map((x) => {
        if (!targetEmpIds.has(x.employeeId)) return x;
        return {
          ...x,
          included: select,
          amount: select
            ? formatCurrencyValue(selectedBatchData?.amount ?? 0)
            : x.amount,
          percentage: select
            ? Number(selectedBatchData?.percentage ?? 0)
            : x.percentage,
        };
      })
    );
  };

  const patchRow = (r, patch) => {
    setRows((prev) =>
      prev.map((x) => (x.employeeId === r.employeeId ? { ...x, ...patch } : x))
    );
  };

  const isCalculationOverridden = (r) => {
    if (!selectedBatchData) return false;
    if (isFixedBatch) {
      return parseCurrency(r.amount) !== Number(selectedBatchData.amount ?? 0);
    }
    return Number(r.percentage) !== Number(selectedBatchData.percentage ?? 0);
  };

  const areAllFilteredSelected =
    filteredRows.length > 0 && filteredRows.every((r) => r.included);

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Batch Employee Selection"
        loading={fetchingBatchEmployees}
        loadingMessage="Loading batch employees..."
        rows={filteredRows}
        rowKey="employeeId"
        searchKeys={['empNo', 'name', 'designation']}
        searchPlaceholder="Search employees..."
        emptyMessage={
          !selectedBatch
            ? 'Please select a batch to assign employees.'
            : 'No matching employees found'
        }
        onAdd={{ label: 'Save Changes', icon: <Save {...ICON} />, onClick: saveChanges }}
        toolbarBeforeSearch={
          <div className="w-[260px] max-w-full">
            <span className={LABEL}>Batch</span>
            <select
              value={selectedBatch}
              onChange={handleBatchChange}
              className={`${FIELD} w-full`}
            >
              <option value="">-- Select Batch --</option>
              {batches.map((batch) => (
                <option key={batch.id} value={batch.id}>
                  {batch.batchNo} - {batch.name}
                </option>
              ))}
            </select>
          </div>
        }
        toolbarExtra={
          <div className="flex flex-wrap items-end gap-3">
            <div className="w-[150px]">
              <span className={LABEL}>Status</span>
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                disabled={!selectedBatch}
                className={`${FIELD} w-full disabled:opacity-50`}
              >
                <option value="ALL">All Employees</option>
                <option value="Not Selected">Not Selected</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>

            {selectedBatch && (
              <button
                type="button"
                onClick={() => toggleSelectAll(!areAllFilteredSelected)}
                className="h-9 px-3 border border-gray-200 rounded-lg text-xs font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors inline-flex items-center gap-1.5 cursor-pointer shadow-xs"
              >
                {areAllFilteredSelected ? (
                  <>
                    <Square size={14} className="text-gray-500" />
                    Deselect All
                  </>
                ) : (
                  <>
                    <CheckSquare size={14} className="text-primary-600" />
                    Select All
                  </>
                )}
              </button>
            )}
          </div>
        }
        columns={[
          {
            key: 'included',
            label: 'Include',
            align: 'center',
            sortable: false,
            render: (r) => (
              <input
                type="checkbox"
                checked={r.included}
                disabled={!selectedBatch}
                onChange={() => toggleIncluded(r)}
                className="w-4 h-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 cursor-pointer accent-primary-600 disabled:opacity-40"
              />
            ),
          },
          {
            key: 'name',
            label: 'Employee',
            grow: true,
            className: 'font-semibold text-gray-900',
            render: (r) => (
              <div>
                <span>{r.name}</span>
                <span className="ml-1.5 text-xs font-normal text-gray-500">({r.empNo})</span>
              </div>
            ),
          },
          { key: 'designation', label: 'Designation', className: 'text-gray-600' },
          {
            key: 'calculation',
            label: isFixedBatch ? 'Amount' : 'Percentage',
            align: 'right',
            sortable: false,
            render: (r) => {
              const overridden = isCalculationOverridden(r);
              const displayVal = isFixedBatch
                ? fmtMoney(parseCurrency(r.amount))
                : `${r.percentage ?? 0}%`;

              return (
                <div className="flex items-center justify-end gap-2">
                  {overridden && (
                    <span className="text-[10px] uppercase font-bold tracking-wider px-1.5 py-0.5 rounded bg-amber-50 text-amber-700 border border-amber-200/60">
                      Overridden
                    </span>
                  )}
                  <span className={overridden ? 'font-bold text-gray-900' : 'text-gray-600'}>
                    {displayVal}
                  </span>
                </div>
              );
            },
          },
          {
            key: 'overrideReason',
            label: 'Reason',
            className: 'text-gray-500 max-w-[180px] truncate',
            render: (r) => r.overrideReason || <span className="text-gray-300">—</span>,
          },
          statusColumn,
          {
            key: 'actions',
            label: 'Actions',
            align: 'center',
            sortable: false,
            render: (r) => (
              <button
                type="button"
                disabled={!r.included || !selectedBatch}
                onClick={() => setEditingRow(r)}
                className="p-1.5 text-gray-500 hover:text-primary-600 hover:bg-gray-100 rounded-md transition-colors disabled:opacity-30 disabled:pointer-events-none"
                title="Override amount or reason"
              >
                <Edit3 size={15} />
              </button>
            ),
          },
        ]}
      />

      <OverrideBatchDialog
        isOpen={Boolean(editingRow)}
        row={editingRow}
        batchType={isFixedBatch ? 'Fixed' : 'Percentage'}
        onClose={() => setEditingRow(null)}
        onSave={(data) => {
          patchRow(editingRow, data);
          setEditingRow(null);
        }}
      />

      <Toast message={toast?.message} type={toast?.type} onClose={hideToast} />
    </>
  );
};

/* ── Batch Employees Preview Modal ───────────────────────────────────────── */
const BatchEmployeesPreviewModal = ({ isOpen, batch, employees, onClose }) => {
  if (!isOpen || !batch) return null;

  const isFixed =
    batch.calculationMethod === 'Fixed' ||
    batch.calculationMethod === 'F';

  const total = employees.reduce((sum, emp) => {
    return sum + (isFixed ? parseCurrency(emp.HPBE_AMOUNT) : 0);
  }, 0);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
      />

      <div className="relative bg-white rounded-xl shadow-xl w-full max-w-3xl max-h-[80vh] flex flex-col mx-4">
        {/* Header */}
        <div className="flex items-start justify-between px-5 py-4 border-b border-gray-200">
          <div>
            <h3 className="text-base font-semibold text-gray-900">
              {batch.batchNo} — {batch.name}
            </h3>
            <p className="text-xs text-gray-500 mt-0.5">
              {employees.length} active employee{employees.length !== 1 && 's'}{' '}
              {isFixed
                ? `• Total: ${fmtMoney(total)}`
                : `• ${batch.percentage ?? 0}% per employee`}
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md cursor-pointer"
          >
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="overflow-y-auto flex-1">
          {employees.length === 0 ? (
            <div className="py-12 text-center text-sm text-gray-500">
              No active employees in this batch.
            </div>
          ) : (
            <table className="w-full text-sm">
              <thead className="bg-gray-50 sticky top-0">
                <tr className="text-left text-xs font-semibold uppercase tracking-wide text-gray-500">
                  <th className="px-4 py-2.5 w-12">#</th>
                  <th className="px-4 py-2.5">Employee</th>
                  <th className="px-4 py-2.5">Service No</th>
                  <th className="px-4 py-2.5 text-right">
                    {isFixed ? 'Amount (Rs)' : 'Percentage'}
                  </th>
                  <th className="px-4 py-2.5">Reason</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {employees.map((emp, i) => (
                  <tr key={emp.HPBE_BATCH_EMPLOYEE_ID || emp.HED_SERVICE_NO}>
                    <td className="px-4 py-2.5 text-gray-400 tabular-nums">
                      {i + 1}
                    </td>
                    <td className="px-4 py-2.5 font-medium text-gray-900">
                      {emp.EMPLOYEE_NAME}
                    </td>
                    <td className="px-4 py-2.5 text-gray-600 tabular-nums">
                      {emp.HED_SERVICE_NO}
                    </td>
                    <td className="px-4 py-2.5 text-right font-semibold text-gray-900 tabular-nums">
                      {isFixed
                        ? fmtMoney(parseCurrency(emp.HPBE_AMOUNT))
                        : `${Number(emp.HPBE_PERCENTAGE ?? 0)}%`}
                    </td>
                    <td className="px-4 py-2.5 text-gray-500 max-w-[200px] truncate">
                      {emp.HPBE_OVERRIDE_REASON || (
                        <span className="text-gray-300">—</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-2 px-5 py-3 border-t border-gray-200 bg-gray-50 rounded-b-xl">
          <button
            type="button"
            onClick={onClose}
            className="h-9 px-4 rounded-lg text-sm font-medium text-gray-700 bg-white border border-gray-200 hover:bg-gray-50 cursor-pointer"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

/* ── Batch Approval ──────────────────────────────────────────────────────── */
const BatchApprovalTab = () => {
  const dispatch = useDispatch();
  const confirm = useConfirm();

  const { list: batches, loading } = usePayrollEntity('batchManagement'); 
  const { toast, showToast, hideToast } = useToast();

  const [batchEmployees, setBatchEmployees] = useState({});
  const [loadingEmployees, setLoadingEmployees] = useState(true);
  const [approvingBatchId, setApprovingBatchId] = useState(null);
  const [previewBatch, setPreviewBatch] = useState(null);

  // Only batches where status = 'Incomplete' appears here
  const pendingBatches = batches.filter(
    (batch) => batch.status === 'Incomplete' || batch.status === 'I'
  );

  // Load employee lists for all incomplete batches
  useEffect(() => {
    let cancelled = false;

    const loadBatchEmployees = async () => {
      if (!pendingBatches.length) {
        setBatchEmployees({});
        setLoadingEmployees(false);
        return;
      }

      setLoadingEmployees(true);

      try {
        const results = await Promise.all(
          pendingBatches.map(async (batch) => {
            try {
              const response = await PayrollBatchEmployeeService.GetPayRollEmpByBatchId(batch.id);

              const employees = response?.data?.ResultSet || [];

              const activeEmployees = employees.filter((emp) => emp.HPBE_IS_ACTIVE === "True");

              return {
                batchId: batch.id,
                employees: activeEmployees,
              };
            } catch (error) {
              console.error(`Failed to load employees for batch ${batch.id}`, error);

              return {
                batchId: batch.id,
                employees: []
              }
            }
          })
        );

        const map = {};

        results.forEach(({ batchId, employees }) => {
          map[batchId] = employees;
        });

        if (!cancelled) {
          setBatchEmployees(map);
        }
      } finally {
        if (!cancelled) {
          setLoadingEmployees(false);
        }
      }
    };

    loadBatchEmployees();

    return () => {
      cancelled = true;
    }
  }, [batches]);

  const getEmployees = (batchId) => batchEmployees[batchId] || [];
  const getCount = (batchId) =>
    batchEmployees[batchId] === undefined ? undefined : batchEmployees[batchId].length;

  const handleApprove = async (batch) => {
    const employeeCount = getCount(batch.id) ?? 0;

    if (employeeCount === 0) {
      showToast(`This batch cannot be approved because it has no employees.`, 'warning');
      return;
    }

    const confirmed = await confirm({
      title: "Approve this batch?",
      message: "After a batch is approved, employees can no longer be added or removed. Do you still wish to proceed?",
      confirmLabel: "Approve",
      cancelLabel: "Cancel",
    })

    if (!confirmed) return;

    try {
      setApprovingBatchId(batch.id);

      await dispatch(savePayrollEntity('batchManagement', {
        batchId: batch.id,
        status: 'A',
      }, true));

      showToast(`Batch ${batch.batchNo} approved successfully.`, 'success');
    } catch (error) {
      console.error(error);
      showToast(error?.message || 'Failed to approve the batch', 'error');
    } finally {
      setApprovingBatchId(null);
    }
  }

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Batch Approval"
        loading={loading}
        rows={pendingBatches}
        rowKey="id"
        searchKeys={['batchNo', 'name', 'description']}
        searchPlaceholder="Search pending batches..."
        emptyMessage="No batches awaiting approval"
        columns={[
          {
            key: 'batchNo',
            label: 'Batch No',
            className: 'font-semibold text-gray-900',
          },
          {
            key: 'name',
            label: 'Batch Name',
            grow: true,
            className: 'text-gray-700',
          },
          {
            key: 'effectiveDate',
            label: 'Effective Date',
            align: 'center',
            className: 'text-gray-600 tabular-nums',
            render: (r) => toIsoDate(r.effectiveDate),
          },
          {
            key: 'calculationMethod',
            label: 'Calculation',
            className: 'text-gray-600',
          },
          {
            key: 'amountPercentage',
            label: 'Amount (Rs) / Percentage',
            align: 'right',
            className: 'font-semibold text-gray-900',
            render: (r) =>
              r.calculationMethod === 'Percentage' ||
              r.calculationMethod === 'P'
                ? `${r.percentage ?? 0}%`
                : fmtMoney(r.amount ?? 0),
          },
          {
            key: 'employeeCount',
            label: 'Employees',
            align: 'center',
            className: 'font-semibold text-gray-900',
            render: (r) => {
              const count = getCount(r.id);

              if (count === undefined) {
                return '...';
              }

              return count;
            },
          },
          statusColumn,
          {
            key: 'approve',
            label: 'Action',
            align: 'center',
            sortable: false,
            render: (r) => {
              const count = getCount(r.id) ?? 0;
              const isApproving = approvingBatchId === r.id;
              const disabled =
                loadingEmployees ||
                count === 0 ||
                isApproving;

              return (
                <div className="inline-flex items-center gap-1.5">
                  <button
                    type="button"
                    disabled={count === 0}
                    onClick={() => setPreviewBatch(r)}
                    className="p-1.5 text-gray-500 hover:text-primary-600 hover:bg-gray-100 rounded-md transition-colors disabled:opacity-30 disabled:pointer-events-none cursor-pointer"
                    title={count === 0 ? 'No employees to preview' : 'Preview employees'}
                  >
                    <Eye size={16} />
                  </button>

                  <button
                    type="button"
                    disabled={disabled}
                    onClick={() => handleApprove(r)}
                    className="
                      inline-flex items-center justify-center
                      rounded-md px-3 py-1.5
                      text-sm font-medium
                      bg-primary-600 text-white
                      hover:bg-primary-700
                      disabled:bg-gray-300
                      disabled:text-gray-500
                      disabled:cursor-not-allowed
                    "
                    title={
                      count === 0
                        ? 'Cannot approve a batch with no employees'
                        : 'Approve batch'
                    }
                  >
                    {isApproving ? 'Approving...' : 'Approve'}
                  </button>
                </div>
              );
            },
          },
        ]}
      />

      <BatchEmployeesPreviewModal
        isOpen={Boolean(previewBatch)}
        batch={previewBatch}
        employees={previewBatch ? getEmployees(previewBatch.id) : []}
        onClose={() => setPreviewBatch(null)}
      />

      <Toast 
        message={toast?.message}
        type={toast?.type}
        onClose={hideToast}
      />
    </>
  );
};

/* ── Page ────────────────────────────────────────────────────────────────── */
const PayrollBatches = () => {
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [refreshBatchEmployees, setRefreshBatchEmployees] = useState(0);

  const { toast, showToast, hideToast } = useToast();

  // Redux data needed by the modal
  const employees = useSelector((state) => state.employees.employees || []);
  const batches = useSelector((state) => state.payroll.entities.batchManagement?.list || []);

  const tabs = [
    { key: 'management', label: 'Batch Management', icon: <Layers {...ICON} />, content: <BatchManagementTab /> },
    { key: 'selection', label: 'Batch Employee Selection', icon: <UserCheck {...ICON} />, content: <BatchEmployeeSelectionTab refreshKey={refreshBatchEmployees} /> },
    { key: 'approval', label: 'Batch Approval', icon: <ClipboardCheck {...ICON} />, content: <BatchApprovalTab /> },
  ];

  return (
    <div className="p-6 space-y-4">
      <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4'>
        <Breadcrumb
          trail={['Payroll', 'Payroll Batches']}
          title="Payroll Batches"
          subtitle="Group employees into payroll batches and route them for approval."
        />

        <button
          type='button'
          onClick={() => setImportModalOpen(true)}
          className='bg-primary-600 text-white hover:bg-primary-700 inline-flex items-center gap-2 h-9 px-4 rounded-lg text-xs font-semibold border border-gray-200 shadow-xs transition-colors shrink-0 self-start sm:self-auto cursor-pointer'
        >
          <Download size={14} className='text-white' />
          Import Batch Employees
        </button>
      </div>

      <Tabs tabs={tabs} defaultTab="management" />

      <ImportBatchEmployeesModal 
        isOpen={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        batches={batches}
        employees={employees}
        onImportSuccess={() => {
          setRefreshBatchEmployees((v) => v + 1)
        }}
      />

      <Toast 
        message={toast?.message}
        type={toast?.type}
        onClose={hideToast}
      />
    </div>
  );
};

export default PayrollBatches;